<template>
  <el-row style="margin-top: 50px">
    <el-col :span="12">
      <div style="line-height: 40px">
        认领对象
        <el-radio-group v-model="form.rldxActive">
          <el-radio
            v-for="item in rldxList"
            :key="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </div>
    </el-col>
    <el-col :span="12" style="display: flex" class="r_col">
      <span style="color: #ff0000; line-height: 40px; margin-right: 5px"
        >*</span
      >
      <div v-if="form.rldxActive == 1">
        <treeselect
          v-model="addTaskForm.ygbhs"
          placeholder="请选择员工"
          :multiple="true"
          :options="deptUser"
          :disable-branch-nodes="true"
          :show-count="true"
          value-consists-of="LEAF_PRIORITY"
          no-results-text="未搜到任何结果"
          :clear-on-select="true"
          :normalizer="normalizer"
          style="width: 100%"
          size="small"
        />
      </div>
      <div v-else-if="form.rldxActive == 2">
        <el-select
          v-model="addTaskForm.bmbhs"
          filterable
          default-first-option
          style="width: 100%"
          :multiple="true"
          placeholder="请选择任务所属部门"
          size="small"
        >
          <el-option
            v-for="(item, index) in allBm"
            :key="index"
            :label="item.bmmc"
            :value="item.bmbh"
          ></el-option>
        </el-select>
      </div>
      <div v-else-if="form.rldxActive == 3">
        <el-select
          v-model="addTaskForm.txlxs"
          filterable
          default-first-option
          style="width: 100%"
          placeholder="请选择任务所属条线"
          size="small"
          :multiple="true"
        >
          <el-option
            v-for="(item, index) in allTxlx"
            :key="index"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import { getBmxxList, getKeyValue } from "@/api/taskType.js";
import { addTask } from "@/api/question.js";
export default {
  computed: {
    ...mapGetters(["deptUser", "user", "question"]),
  },
  components: { Treeselect },
  props: ["mxParams"],
  data() {
    return {
      form: {
        rldxActive: 1,
      },
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      rldxList: [
        {
          label: "部门",
          value: 2,
        },

        {
          label: "条线",
          value: 3,
        },
        {
          label: "员工",
          value: 1,
        },
      ],
      addTaskForm: {
        ygbhs: null,
        bmbhs: null,
        txlxs: null,
      },
      allTxlx: [],
      allBm: [],
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.allBm = res.data;
        let temp = [];
        for (let i of this.allBm) {
          temp.push(i.bmbh);
        }
        temp = temp.toString();
        this.allBm.unshift({
          bmbh: temp,
          bmmc: "全部",
        });
      }
    });

    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.allTxlx = res.data;
      }
    });
  },
  mounted() {},
  methods: {
    saveForm() {
      let str = null;
      const { rldxActive } = this.form;
      if (rldxActive == 1 && this.addTaskForm.ygbhs) {
        str = this.addTaskForm.ygbhs.join(",");
      } else if (rldxActive == 2 && this.addTaskForm.bmbhs) {
        str = this.addTaskForm.bmbhs.join(",");
      } else if (rldxActive == 3 && this.addTaskForm.txlxs) {
        str = this.addTaskForm.txlxs.join(",");
      }
      if (!str) {
        this.$message.error("请选择认领对象");
        return;
      }
      const params = {
        id: this.mxParams.id,
        rldx: rldxActive,
        str,
      };
      addTask(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.$emit("giveFather", this.parentDialog);
          return true;
        } else {
          this.$message.error(res.msg);
          return false;
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.upload-tips {
  position: absolute;
  top: 0px;
  left: 140px;
}
.r_col {
  div {
    width: 100%;
  }
}
</style>